// hooks/useSubjectCoefficients.ts
import { useState, useCallback } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { ClassLevel } from "types/classLevelTypes";
import { getAllSubjectCoefficientsByClassLevel , createSubjectCoefficient , deleteSubjectCoefficient } from "services/subjectCoefficientService";

type FetchParams = {
  schoolCycle?: string; // e.g. "primary_school"
};

export const useSubjectCoefficients = () => {
  const { t } = useTranslation();

  const [classLevels, setClassLevels] = useState<ClassLevel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSubjectCoefficients = async (params: FetchParams = {}) => {
      setLoading(true);
      try {
        const data = await getAllSubjectCoefficientsByClassLevel(params);
        setClassLevels(data || []);
        setError(null);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    const saveSubjectCoefficient = async (payload: any) => {
      setLoading(true);
      try {
        await createSubjectCoefficient(payload);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    const removeSubjectCoefficient = async (id: string) => {
      setLoading(true);
      try {
        await deleteSubjectCoefficient(id);
        message.success(t("subject_coefficient_deleted_successfully"));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

  return {
    classLevels,          // Array<ClassLevel>
    loading,
    error,
    fetchSubjectCoefficients,
    saveSubjectCoefficient,
      removeSubjectCoefficient
  };
};

export default useSubjectCoefficients;
